module.exports = __webpack_public_path__ + "img/hd.c13ef927.png";